"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Quill = require("quill");
var BaseModule_1 = require("./BaseModule");
var IconAlignCenter = require("quill/assets/icons/align-center.svg");
var IconAlignLeft = require("quill/assets/icons/align-left.svg");
var IconAlignRight = require("quill/assets/icons/align-right.svg");
var Parchment = Quill.import('parchment');
var FloatStyle = new Parchment.Attributor.Style('float', 'float');
var MarginStyle = new Parchment.Attributor.Style('margin', 'margin');
var DisplayStyle = new Parchment.Attributor.Style('display', 'display');
/**
 * Appends a simple toolbar to images, for aligning an image left, center, or right
 *
 * @export
 * @class Toolbar
 * @extends {BaseModule}
 */
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar.prototype.onCreate = function () {
        this.toolbarElement = document.createElement('div');
        lodash_1.assign(this.toolbarElement.style, this.options.toolbarStyles);
        this.overlay.appendChild(this.toolbarElement);
        this.createToolbarButtons();
    };
    /**
     * Creates Toolbar buttons to display when an image is "active"
     *
     * @private
     *
     * @memberof Toolbar
     */
    Toolbar.prototype.createToolbarButtons = function () {
        var buttons = [];
        var self = this;
        var alignments = this.createAlignments();
        var _loop_1 = function (i) {
            var toolbarButton = document.createElement('span');
            toolbarButton.innerHTML = alignments[i].icon;
            toolbarButton.addEventListener('click', function (event) {
                buttons.forEach(function (button) { return button.style.filter = ''; });
                if (alignments[i].isApplied()) {
                    FloatStyle.remove(self.img);
                    MarginStyle.remove(self.img);
                    DisplayStyle.remove(self.img);
                    // Important to reset already assigned class
                    self.img.className = '';
                }
                else {
                    // Important to reset already assigned class, preventing multiple classes to be assigned to the image, before applying a new style
                    self.img.className = '';
                    this.style.filter = 'invert(20%)';
                    alignments[i].apply();
                }
                self.imageResize.onUpdate();
            });
            lodash_1.assign(toolbarButton.style, this_1.options.toolbarButtonStyles);
            if (i > 0)
                toolbarButton.style.borderLeftWidth = '0';
            lodash_1.assign(toolbarButton.children[0].style, this_1.options.toolbarButtonSvgStyles);
            if (alignments[i].isApplied())
                toolbarButton.style.filter = 'invert(20%)';
            buttons.push(toolbarButton);
            this_1.toolbarElement.appendChild(toolbarButton);
        };
        var this_1 = this;
        for (var i = 0; i < alignments.length; ++i) {
            _loop_1(i);
        }
    };
    /**
     * Create the different alignment styles when the different alignment buttons are activated
     *
     * @private
     * @returns
     *
     * @memberof Toolbar
     */
    Toolbar.prototype.createAlignments = function () {
        var _this = this;
        var left = {
            icon: IconAlignLeft,
            apply: function () {
                FloatStyle.add(_this.img, 'left');
                MarginStyle.add(_this.img, '0 1em 1em 0');
                DisplayStyle.add(_this.img, 'inline');
                _this.img.classList.add('quill-align-left');
            },
            isApplied: function () {
                return _this.img.classList.contains('quill-align-left');
            }
        };
        var center = {
            icon: IconAlignCenter,
            apply: function () {
                FloatStyle.remove(_this.img);
                MarginStyle.add(_this.img, 'auto');
                DisplayStyle.add(_this.img, 'block');
                _this.img.classList.add('quill-align-center');
            },
            isApplied: function () {
                return _this.img.classList.contains('quill-align-center');
            }
        };
        var right = {
            icon: IconAlignRight,
            apply: function () {
                FloatStyle.add(_this.img, 'right');
                MarginStyle.add(_this.img, '0 0 1em 1em');
                DisplayStyle.add(_this.img, 'inline');
                _this.img.classList.add('quill-align-right');
            },
            isApplied: function () {
                return _this.img.classList.contains('quill-align-right');
            }
        };
        return [left, center, right];
    };
    Toolbar.prototype.onDestroy = function () {
        // Doesn't require implementation
    };
    Toolbar.prototype.onUpdate = function () {
        // Doesn't require implementation
    };
    return Toolbar;
}(BaseModule_1.BaseModule));
exports.Toolbar = Toolbar;
//# sourceMappingURL=Toolbar.js.map